<template>
  <div class="modal-card">
    <header
      class="modal-card-head"
      :class="headerClass"
    >
      <p class="modal-card-title has-text-white has-text-centered">
        {{ title }}
      </p>
    </header>

    <section class="modal-card-body">
      <p>{{ message }}</p>
    </section>

    <footer
      class="modal-card-foot"
      :class="
        actionText && dismissText
          ? 'has-content-justified-between'
          : 'has-content-justified-end'
      "
    >
      <button
        v-if="dismissText"
        type="button"
        class="button"
        :class="actionText ? 'is-light' : type"
        @click="dismiss"
      >
        {{ dismissText }}
      </button>

      <button
        v-if="actionText"
        type="button"
        class="button"
        :class="type"
        @click="action"
      >
        {{ actionText }}
      </button>
    </footer>
  </div>
</template>

<script>
export default {
  name: "NoticeModal",
  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: "is-danger"
    },
    dismissText: {
      type: String,
      default: "Dismiss"
    },
    actionText: {
      type: String,
      default: null
    }
  },
  computed: {
    headerClass() {
      return `has-background-${this.type.replace("is-", "")}`;
    }
  },
  methods: {
    /* 'close' dismisses the modal itself; the paired event lets the opener
    react to which button was pressed. Buefy's 'onCancel' only covers
    esc/outside/x, so it can't distinguish these. */
    action() {
      this.$emit("close");
      this.$emit("action");
    },
    dismiss() {
      this.$emit("close");
      this.$emit("dismiss");
    }
  }
};
</script>
